import * as React from "react";
import {
  getKnowiHashEndPoint,
  setForceResetBaseLineCountEndPoint,
  setBaseLineCountEndPoint,
  setAllBaseLineCountEndPoint,
  getWidgetMatrixDataEndPoint,
  getParkingOccupancyDatamatrixWidgetEndPoint,
  getCrowdDensityDatamatrixWidgetEndPoint,
  getInOutCountForEEAppsDatamatrixWidgetEndPoint,
  getParkingOccupancyOADatamatrixWidgetEndPoint,
  getCrowdDensityDataEndPoint,
  fetchStatsDataForEventAppsEndPoint,
  getStatOpenAreaMaxAvgEndPoint,
  getEntryExitWidgetEndPoint,
  getDwellTimeDataEndPoint
} from "../../configuration";
import { getRandomUUID } from "../../Token";
import { ArrowDropDown, ArrowDropUp } from "@mui/icons-material";
import { getAggregateForstatistics } from "../../model/reportService";
import moment from "moment-timezone";
import axiosInstance from "../axiosInterceptor";
import { capitalizeWords } from "../../api/utils";
import { CVAPP_OBJECTBLUR } from "../constants/cvappConstants";

export const deploymentstatusList = ["deployed", "undeploy_failed", "updating", "update_failed"];


export const dataliter = (data) => {
  const d = [];
  if (Array.isArray(data)) {
    data.forEach((element) => {
      if (element?.tagids !== undefined) {
        element?.tagids.forEach((e) => {
          if (d.indexOf(e) === -1) {
            d.push(e);
          }
        });
      }
    });
  }
  return d;
};

const hasDeployedStatus = (deployments) => {
  return Array.isArray(deployments) && deployments.some((deployedRoi) => deploymentstatusList.includes(deployedRoi?.status));
};

export const isRoiWithDeployedStatus = (roiItem) => {
  return roiItem?.deployments !== undefined && hasDeployedStatus(roiItem.deployments);
};

export const isValidRoiWithSiteAndApp = (roiItem, allSiteIds = [], appName = null, excludeObjectBlur = false) => {
  return (
    roiItem?.cvapps !== undefined &&
    roiItem?.tagids !== undefined &&
    roiItem.siteids !== undefined &&
    (allSiteIds.length === 0 || allSiteIds.indexOf(roiItem.siteids[0]) !== -1) &&
    (appName === null || roiItem?.cvapps[0].name.indexOf(appName) !== -1) &&
    (!excludeObjectBlur || roiItem?.cvapps[0]?.resources?.displayName !== CVAPP_OBJECTBLUR)
  );
};

export const getSelectedTagList = (selectedSubAreas, selectedAreas, selectedFloors, selectedSite, siteList) => {
  return selectedSubAreas?.length > 0
    ? selectedSubAreas
    : selectedAreas?.length > 0
    ? selectedAreas
    : selectedFloors?.length > 0
    ? selectedFloors
    : selectedSite.length > 0
    ? selectedSite
    : [siteList[0]];
};

export const getTagListForEncryptAPI = (selectedSubAreas, selectedAreas, selectedFloors, selectedSite, siteList) => {
  return getSelectedTagList(selectedSubAreas, selectedAreas, selectedFloors, selectedSite, siteList)?.map((e) => {
    return "id~" + e?.id + "=name~" + e?.name + "=maxParkings~" + e?.parkingcount + "=virtualId~" + e?.virtualId;
  });
};

export function processUnmatchedTagMatches(mapRoiListBasedOnSites, roisListWithApps, appNameForViewTag, sitesReducer) {
  var result = mapRoiListBasedOnSites(roisListWithApps, appNameForViewTag);
  let sortedKeys = Object.keys(result).sort();
  let selectedSite = sitesReducer.sites.find((s) => s.name === sortedKeys[0]) || null;
  const allRois = selectedSite ? result[selectedSite.name] : null;
  if (allRois) {
    const unmatchedTagIds = [];
    allRois.forEach((roi) => {
      if (Array.isArray(roi?.customdata?.statisticstagids) && roi.customdata.statisticstagids.length > 0) {
        roi.customdata.statisticstagids.forEach((tagid) => {
          unmatchedTagIds.push(tagid);
        });
      } else if (Array.isArray(roi.tagids)) {
        roi.tagids.forEach((tagid) => {
          unmatchedTagIds.push(tagid);
        });
      }
    });

    const unmatchedSiteTagIds = [];
    allRois.forEach((roi) => {
      if (Array.isArray(roi?.siteids) && roi.siteids.length > 0) {
        roi.siteids.forEach((tagid) => {
          unmatchedSiteTagIds.push(tagid);
        });
      }
    });
    let uniqueUnmatchedTagIds = [...new Set(unmatchedTagIds), ...[...new Set(unmatchedSiteTagIds)]];
      uniqueUnmatchedTagIds = [...new Set(uniqueUnmatchedTagIds)];

      return segregateLocationsOnBaisOfType(uniqueUnmatchedTagIds,sitesReducer,selectedSite, roisListWithApps, appNameForViewTag);
  }
  else {
    return {
      floors: [],
      areas: [],
      subareas: [],
      site: []
    };
  }
}

export function segregateLocationsOnBaisOfType(uniqueUnmatchedTagIds, sitesReducer,selectedSite, roisListWithApps, appNameForViewTag){
  const matches = uniqueUnmatchedTagIds.map((tagid) => {
      return {
        floor: sitesReducer.floors.find((floor) => floor.id.includes(tagid)) || {},
        area: sitesReducer.areas.find((area) => area.id.includes(tagid)) || {},
        subarea: sitesReducer.subareas.find((subarea) => subarea.id.includes(tagid)) || {},
        site: selectedSite?.id?.includes(tagid) ? selectedSite : {}
      };
    });

   
    const newFloors = [];
    const newAreas = [];
    const newSubAreas = [];
    const newSite = [];

    matches.forEach((match) => {
      if (match?.site && match?.site?.id) {
        newSite.push({
          id: match.site.id,
          name: match.site.name,
          tagids: Array.isArray(match.site.tagids) ? match.site.tagids : [match.site.tagids],
          parkingcount: match.site.parkingcount === undefined ? 0 : match.site.parkingcount,
          virtualId: getDeviceVirtualIdFromTagId(match.site.id, roisListWithApps, appNameForViewTag)
        });
      }
      if (match?.floor && match?.floor?.id) {
        newFloors.push({
          id: match.floor.id,
          name: match.floor.name,
          tagids: Array.isArray(match.floor.tagids) ? match.floor.tagids : [match.floor.tagids],
          parkingcount: match.floor.parkingcount === undefined ? 0 : match.floor.parkingcount,
          virtualId: getDeviceVirtualIdFromTagId(match.floor.id, roisListWithApps, appNameForViewTag)
        });
      }
      if (match?.area && match?.area?.id) {
        newAreas.push({
          id: match.area.id,
          name: match.area.name,
          tagid: Array.isArray(match.area.tagids) ? match.area.tagids : [match.area.tagids],
          parkingcount: match.area.parkingcount === undefined ? 0 : match.area.parkingcount,
          virtualId: getDeviceVirtualIdFromTagId(match.area.id, roisListWithApps, appNameForViewTag)
        });
      }
      if (match?.subarea && match?.subarea?.id) {
        newSubAreas.push({
          id: match.subarea.id,
          name: match.subarea.name,
          tagid: Array.isArray(match.subarea.tagids) ? match.subarea.tagids : [match.subarea.tagids],
          parkingcount: match.subarea.parkingcount === undefined ? 0 : match.subarea.parkingcount,
          virtualId: getDeviceVirtualIdFromTagId(match.subarea.id, roisListWithApps, appNameForViewTag)
        });
      }
    });
    return {
      floors: newFloors,
      areas: newAreas,
      subareas: newSubAreas,
      site: newSite
    };
}

export function filterRoiCvappfromSiteSelection(filteredCvAppROiList, widgetDisplayName, taggedSelection) {
  const rois = filteredCvAppROiList.filter(f => {
    return f?.cvapps?.[0]?.resources?.displayName === widgetDisplayName;
  }) || [];
  
  const roitdevs = rois.filter(r => {
    if (r?.cvapps?.[0]?.name?.indexOf("EE") !== -1) {
      return r?.deployments?.[0]?.config?.locationDeviceMapping !== undefined && 
             Object.keys(r.deployments[0].config.locationDeviceMapping).filter(m => {
               return taggedSelection?.map(t => t?.id).indexOf(m) !== -1;
             }).length;
    } else {
      return r?.tagids !== undefined && 
             r.tagids.filter(m => {
               return taggedSelection?.map(t => t?.id).indexOf(m) !== -1;
             }).length;
    }
  });

  return roitdevs;
}

export const getFormattedDate = (timeStamp) => {
  if (timeStamp) {
    return moment(timeStamp).format("MM/DD/YYYY");
  }
  return "";
};

export function getWidgetDisplayName(widget, selectedCVAppName) {
  const widgetDisplayName = widget?.name.indexOf("_")
    ? widget?.name.split("_")[0]
    : widget?.name;
  var eventAPpName = (widget?.name.indexOf("EventApp") > -1) ?  selectedCVAppName : widgetDisplayName;
  return widget?.name.indexOf("_ev_eventnameloc_") > -1 ? eventAPpName.toUpperCase() : widgetDisplayName.toUpperCase();
}
export function getWidgetDisplayNameForIcon(widget) {
  const widgetDisplayName = widget?.name.replaceAll(" ", "");
  return widgetDisplayName.toLowerCase();
}
export function extractNameFromFullWidgetName(fullwidgetName) {
  const widgetDisplayName =
    fullwidgetName.indexOf("_") > -1
      ? fullwidgetName.split("_")[0]
      : fullwidgetName;
  return widgetDisplayName;
}
export function extractNameFromFullWidgetNameForWidgetFilter(fullwidgetName) {
  var widgetDisplayName =
    fullwidgetName.indexOf("_") > -1
      ? fullwidgetName.split("_")[0]
      : fullwidgetName;
  widgetDisplayName =
    fullwidgetName.indexOf("_Event_lvl") > -1
      ? "_eventname_"
      : "_" + widgetDisplayName.toLowerCase().replaceAll(" ", "") + "_";
  return widgetDisplayName;
}
export function extractNameFromFullWidgetNameForWidgetFilterOFFLoors(
  fullwidgetName,
  widgetListFromWidgetstate
) {
  var widgetDisplayName = fullwidgetName;
    const i = widgetListFromWidgetstate.find(m => {return (m.name.indexOf("loc") > -1 && m.name.indexOf(fullwidgetName.replace(" ", "").toLowerCase()) > -1) ||
      (m.name.indexOf("_eventname") > -1)
    });
  if (!i) {
    return "_" + fullwidgetName.toLowerCase().replaceAll(" ", "");
  }
  widgetDisplayName =
    i.name.indexOf("_eventname") > -1
      ? "_eventname"
      : "_" + fullwidgetName.toLowerCase().replaceAll(" ", "");
  return widgetDisplayName;
}

export function arrangeWidgetNameAsAlphabeticalOrder(widgets) {
  return [...widgets].sort((a, b) => a.name.localeCompare(b.name));
}

export function arrangeAsAlphabeticalOrder(widgets) {
  return [...widgets].sort((a, b) => a.localeCompare(b));
}

export function arrangeAsAlphabeticalOrderWithField(widgets, fieldname) {
  return [...widgets].sort((a, b) => a[fieldname].localeCompare(b[fieldname]));
}

export function getUTCDateFromPickerDate(dateString) {
  return new Date(dateString).toISOString();
}
export function getPickerDateFromUTCDate(utcdate) {
  var g = moment(utcdate).format("YYYY-MM-DD HH:mm");
  return g;
}
export function getPickerDateFromUTCDateForFilter(utcdate) {
  var g = moment(utcdate).format("MM/DD/YYYY HH:mm A");
  return g;
}

export function getDateForKNOWIAPis(d) {
  var m = new Date(
    d.getFullYear(),
    d.getMonth(),
    d.getDate(),
    d.getHours(),
    d.getMinutes()
  ).toISOString();
  return m;
}

export function getParentWidgetName(fullwidgetName, cvAppNames) {
  const widgetDisplayName =
    fullwidgetName.indexOf("_") > -1
      ? fullwidgetName.split("_")[0]
      : fullwidgetName;
  const  g = cvAppNames.find(l => {return l?.resources?.displayName?.toLowerCase() == widgetDisplayName?.toLowerCase()});
  return g?.image;

  // if(widgetDisplayName === "Person and Vehicle Detection"){
  //   return "RestrictedAreaViolation";
  // } else if(widgetDisplayName === "Missing Personal Protective Equipment"){
  //   return "MissingPPE"
  // } else if(widgetDisplayName === "Stream Monitoring"){
  //   return "CameraAdjustment"
  // } else {
  //   return widgetDisplayName.replaceAll(" ", "");
  // }
}

//case "object detection": return "ObjectDetection";
// case "slip and fall": return "SlipAndFall";
// case "average people count": return "peopleCount";
// case "smoke detection": return "SmokeDetection";
// case "open door detection": return "OpenDoorDetection";
// case "camera adjustment": return "CameraAdjustment";
// case "crowd density": return "CrowdDensity";
// case "proximity detection": return "ProximityDetection";
// case "unattended object detection": return "UnattendedObjectDetection";
// case "ppe usage": return "PpeUsage";

// export function getWidgetListBasedOnselection(siteName, appName){
//   if(siteName ==  "All Sites"){
//     if(appname == "All Apps"){
//       return ["People Count_MultiSite_lvl1_1120",
//         "Dwell Time_multi_lvl1_1020",
//         "Vehicle Count_MultiSite_lvl1_1020",
//         "Slip And Fall_Multi_Event_lvl1_1121",
//         "Restricted area violation_MultiFloor_Event_lvl1_1121",
//         "Object Detection_Multi_Event_lvl1_1121"]
//     }

//   }
// }

export function getBaseLineCountText(appName) {
  switch (appName.toLowerCase()) {
    case "people count":
      return "Number of people";
    case "vehicle count":
      return "Number of vehicles";
    default:
      return "Parking spots occupied";
  }
}

export function getIcon(iconName, selectedCVAppName="") {
  switch (iconName.toLowerCase()) {
    case "people count":
    case "people counting ee":
    case "people counting fa":
    case "people count comparision":
      return "group-family";
    case "dwell time":
    case "total dwell time":
    case "average dwell time":
    case "max dwell time":
      return "timer";
    case "entry exit":
      return "switch";
    case "person detection":
      return "audience-targeted-search";
    case "object detection":
      return "box-open";
    case "unattended object detection":
      return "pack-backpack";
    case "slip and fall":
      return "fall-detected";
    case "average people count":
      return "group-family";
    case "vehicle count":
    case "average vehicle count":
    case "vehicle count comparision":
      return "on-go-car";
    case "time to event resolution comparision":
    case "event over time":
     case "time to event resolution":
    return getIcon(selectedCVAppName);
    case "smoke detection":
      return "fire";
    case "parking occupancy":
    case "parking lot occupancy":
    case "parking iot occupancy":
    case "parking occupancy comparision":
    case "average parking occupancy":
      return "fleet";
    case "crowd counting":
    case "average crowd counting":
    case "crowd counting comparision":
      return "inclusivity"
    case "missing personal protective equipment":
      return "passenger";
    case "vehicle detection":
      return "shipping";
    case "proximity detection":
      return "social-distancing";
    case "stream monitoring":
      return "wireless-video-surveillance";
    default:
      return "timer";
  }
}

export const trendIconSelect = (netValue) => {
  if (netValue >= 1) {
    return <ArrowDropUp viewBox="3 3 15 15" />;
  } else if (netValue === 0) {
    return (
      <div style={{ fontSize: "12px", textAlign: "center", margin: "8px 8px" }}>
        --
      </div>
    );
  } else if (netValue < 0) {
    return <ArrowDropDown viewBox="5 3 15 15" />;
  }
};

export const getNotificationObj = (title, successStatus)=>{
  return  {
    type: (successStatus) ? "Success" : "Failed",
    title: title,
    priority: successStatus ? "success" : "critical",
    data: "data",
    showNotification: true
  }
}

export const isWidgetOfEventApp =  (cvAppNames, appName) =>{
const apptype = cvAppNames.find(f => {return f.resources.displayName == appName || f?.image === appName})?.category;
return apptype != "Statistics Apps";
}

export const getDeviceVirtualIdFromTagId = (tagid, roisListWithApps, cvappName) => {
  if(!roisListWithApps || !cvappName){
    return "";
  }
    const areabasedcvappsRois  = roisListWithApps.filter(cvapp => {
  return cvapp?.cvapps?.[0]?.resources?.displayName == cvappName &&  
         cvapp?.tagids?.indexOf(tagid) > -1 &&   
         cvapp?.deployments?.[0]?.status && 
         deploymentstatusList.includes(cvapp.deployments[0].status) &&  
         cvapp?.deployments[0]?.config?.locationDeviceMapping != undefined && 
         Object.keys(cvapp.deployments[0].config.locationDeviceMapping).indexOf(tagid) > -1
  });
  const tagVirtualIds = [...new Set(areabasedcvappsRois.map(m => {return m?.deployments[0].config?.locationDeviceMapping[tagid] }))];
  return  tagVirtualIds.length > 0 ? tagVirtualIds[0] : "";
}


export const convertTimeToDropdownValue = (time) => {
  return new Date(time).toString().split(":")[0].slice(-2);
}
export const convertTimeToBaseLineDropdownValue = (allBaselineData,statBaseSettingsTag, roisListWithApps, cvappName) => {
  const baseLineTrigger = allBaselineData.find((i) => {return (i?.customdata.deviceid === getDeviceVirtualIdFromTagId(statBaseSettingsTag[0].id, roisListWithApps, cvappName))  });

const time = baseLineTrigger == undefined ? Date.now():  baseLineTrigger?.lastupdated.split("T")[0] + "T" + baseLineTrigger?.starttime.split("T")[1];
  return new Date(time).toString().split(":")[0].slice(-2);
}

export const getEncryptedHash = async (payload) => {
  try {
    const response = await axiosInstance.post(getKnowiHashEndPoint(), {
        contentfilters: payload,
    });
    const res = response.data;
    return res;
  } catch (e) {
    console.log(e);
    return;
  }
};

export const setForceResetForBaseLineCount = async (payload) => {
  try {
    const response = await axiosInstance.post(setForceResetBaseLineCountEndPoint(), 
      payload,
    );
    return response;
  } catch (e) {
    console.log(e);
    return;
  }
};

export const setTagsBaseLineCount = async (payload) => {
  try {
    const response = await axiosInstance.post(setBaseLineCountEndPoint(), 
      payload,
    );
    return response;
  } catch (e) {
    console.log(e);
    return;
  }
};

export const setAllTagsBaseLineCount = async (activeSession) => {
  const payload = 
  {
    "accountName": activeSession?.accountId,
    "filter": { "$selection": {
      "kind": "ts.schedule.calendar.device.event",
    },
    }
  }

  try {
    const response = await axiosInstance.post(setAllBaseLineCountEndPoint(), 
      payload,
    );
    return response;
  } catch (e) {
    console.log(e);
    return;
  }
};
export const invokeHIstoryAPIForKNOWI = async (payload) => {
  try {
    const response = await axiosInstance.post(getKnowiHashEndPoint(), {
        contentfilters: payload,
    });
    const res = response.data;
    return res;
  } catch (e) {
    console.log(e);
    return;
  }
};
export const getWidgetMatrixData = async (payload) => {
  try {
    const response = await axiosInstance.post(getWidgetMatrixDataEndPoint(), payload,
    );
    const res = response.data;
    return res;
  } catch (e) {
    console.log(e);
    return;
  }
};

export const getWidgetDataForEventApps = async (payload) => {
  try {
    const response = await axiosInstance.post(fetchStatsDataForEventAppsEndPoint(), payload,
    );
    const res = response.data;
    return res;
  } catch (e) {
    console.log(e);
    return;
  }
};

export const getParkingOccupancyWidgetMatrixData = async (payload) => {
  try {
    const response = await axiosInstance.post(getEntryExitWidgetEndPoint(), payload,
    );
    const res = response.data;
    return res;
  } catch (e) {
    console.log(e);
    return;
  }
};

export const getParkingOccupancyOAWidgetMatrixData = async (payload) => {
  try {
    const response = await axiosInstance.post(getParkingOccupancyOADatamatrixWidgetEndPoint(), payload,
    );
    const res = response.data;
    return res;
  } catch (e) {
    console.log(e);
    return;
  }
};

export const getInOutCountForEEAppsWidgetMatrixData = async (payload) => {
  try {
    const response = await axiosInstance.post(getInOutCountForEEAppsDatamatrixWidgetEndPoint(), payload,
    );
    const res = response.data;
    return res;
  } catch (e) {
    console.log(e);
    return;
  }
};


export const getCrowdDensityWidgetMatrixData = async (payload) => {
  try {
    const response = await axiosInstance.post(getCrowdDensityDataEndPoint(), payload,
    );
    const res = response.data;
    return res;
  } catch (e) {
    console.log(e);
    return;
  }
};

export const getStatOaMaxAvgOfWidgetData = async (payload) => {
  try {
    const response = await axiosInstance.post(getStatOpenAreaMaxAvgEndPoint(), payload,
    );
    const res = response.data;
    return res;
  } catch (e) {
    console.error(e);
    return;
  }
};

export const toMin = (val) => {
  const totalSec = parseFloat(val) || 0;
  let h = Math.floor(totalSec / 3600);
  let m = Math.floor((totalSec % 3600) / 60);
  let s = (totalSec % 60).toFixed(2);
  if (s === "60.00") {
    s = "0.00";
    m += 1;
    if (m === 60) {
      m = 0;
      h += 1;
    }
  }
  const parts = [];
  if (h > 0) parts.push(`${h}h`);
  if (m > 0) parts.push(`${m}m`);
  if (parseFloat(s) > 0) parts.push(`${s}s`);
  return parts.length > 0 ? parts.join(" ") : "0s";
};

export const getTimeLabelWithTimezone = () => {
  const timeZone = moment.tz.guess();
  const timeZoneAbbr = moment().tz(timeZone).format("z");
  return `Time (${timeZoneAbbr})`;
};

export const getDwellTimeWidgetMatrixData = async (payload) => {
  try {
    const response = await axiosInstance.post(getDwellTimeDataEndPoint(), payload);
    const res = response.data;
    return res;
  } catch (e) {
    console.log(e);
    return;
  }
};



export const getEntryExitStats = async (
  tagid,
  activeSession,
  startDate,
  isEventApp,
  encryptPayload
) => {

var filterAggregate = [];
var aggregationfilter = '';
if(isEventApp){
 filterAggregate = [
    {
      name: "UnresolvedEventCount",
      kind: "count",
      field: encryptPayload?.eventfieldForPriority,
    }
  ];

  aggregationfilter = `(createdon > '${new Date(startDate).toISOString()}') and ($/fields/PeopleDetection/status eq 'Unresolved')`;
}else{
 filterAggregate = [
    {
      name: "EntryIn_overtime",
      kind: "sum",
      field: "fields.PeopleCountEE.in",
      datehistogram: {
        field: "createdon",
        fixedinterval: encryptPayload.histogram_fixedinterval,
      },
    },
    {
      name: "EntryOut_overtime",
      kind: "sum",
      field: "fields.PeopleCountEE.out",
      datehistogram: {
        field: "createdon",
        fixedinterval: encryptPayload.histogram_fixedinterval,
      },
    },
    {
      name: "VehicleCountIn_overtime",
      kind: "sum",
      field: "fields.VehicleCount.in",
      datehistogram: {
        field: "createdon",
        fixedinterval: encryptPayload.histogram_fixedinterval,
      },
    },
    {
      name: "VehicleCountOut_overtime",
      kind: "sum",
      field: "fields.VehicleCount.out",
      datehistogram: {
        field: "createdon",
        fixedinterval: encryptPayload.histogram_fixedinterval,
      },
    },
    
  ];
  aggregationfilter = `(createdon > '${new Date(startDate).toISOString()}')`;
}


  const resp = await getAggregateForstatistics(
    aggregationfilter,
    // `createdon > '2024-09-18T10:55:00.000Z'`,
    tagid,
    activeSession,
    filterAggregate
  );

  var aggCounter = {};
  aggCounter.inCountSum = 0;
  aggCounter.outCountSum = 0;
  aggCounter.UnresolvedEventCountCritical = 0;
  aggCounter.UnresolvedEventCountMinor = 0;
  
  aggCounter.UnresolvedEventCountCritical = 0;
  aggCounter.UnresolvedEventCountMinor = 0;
  

  if (resp != undefined && Object.keys(resp).length > 0) {
    //aggCounter.inCountSum = resp?.EntryIn_overtime[0]?.count;
   // aggCounter.outCountSum = resp?.EntryOut_overtime[0]?.count;
    if (resp?.UnresolvedEventCount?.length > 0) {
      aggCounter.UnresolvedEventCountCritical =
        resp?.UnresolvedEventCount[0].key == "Critical"
          ? resp?.UnresolvedEventCount[0].count
          : resp?.UnresolvedEventCount.length > 1
          ? resp?.UnresolvedEventCount[1].count
          : 0;
      aggCounter.UnresolvedEventCountMinor =
        resp?.UnresolvedEventCount[0].key == "Minor"
          ? resp?.UnresolvedEventCount[0].count
          : resp?.UnresolvedEventCount.length > 1
          ? resp?.UnresolvedEventCount[1].count
          : 0;
    }
   
  }

  return aggCounter;
  //setAggregatedCVAppCount(aggCounter);
};

export const getAppName = (state, pathParam, defaultApp) => {
  if (state?.appName) {
    return state.appName;
  } else if (pathParam) {
    const decoded = decodeURIComponent(pathParam);
    const normalized = decoded.replace(/[_-]/g, " ");
    return capitalizeWords(normalized);
  } else {
    return defaultApp;
  }
};

export const setpathParam = (appName) => {
  if(appName){
    return encodeURIComponent(appName.replaceAll(" ", "_").toLowerCase());
  }
  return "";
};